// Module
var code = `<form name="\$ctrl.formNi" novalidate>
    <div>
      <table class="table">
        <tbody class="tbody">
        <tr>
          <td class="label">Contract Status:</td>
          <td class="values">
            <select
              ng-model="\$ctrl.negativeInformation.contractStatus"
              ng-options="item.value as item.label for item in \$ctrl.contractStatus">
              ng-disabled="!\$ctrl.isEditModeEnabled()">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Probability of default:</td>
          <td class="values">
            <glue-container append-percentage="true">
              <input type="text"
                     ng-model="\$ctrl.negativeInformation.probabilityOfDefault"
                     ng-change="\$ctrl.onProbabilityOfDefaultChange()"
                     ng-currency
                     currency-symbol
                     fraction="4"
                     ng-disabled="!\$ctrl.isEditModeEnabled()"/>
            </glue-container>
          </td>
        </tr>
        <tr>
          <td class="label">Other deferred credits</td>
          <td class="values">
            <glue-container append-percentage="true">
              <cash ng-model="\$ctrl.negativeInformation.otherDeferredCredits"
                  min="0"
                  ng-disabled="!\$ctrl.isEditModeEnabled()">
              </cash>
            </glue-container>
            <help title="Additional deferred credits outside the CBS"></help>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/details/negative-information/negative-information.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;